import { store } from '@/app/store'
import { adminPortalApi } from '@/data/admin/api/admin_portal_api'

export class PostsRtkDatasource {
  async list(page = 0, limit = 50) {
    const result = await store.dispatch(
      adminPortalApi.endpoints.getAdminPosts.initiate({ page, limit })
    )
    if (result.error) throw result.error
    return result.data ?? []
  }

  async delete(id: string) {
    const result = await store.dispatch(
      adminPortalApi.endpoints.deleteAdminPost.initiate(id)
    )
    if (result.error) throw result.error
  }
}
